import React from "react";
import { extractUserSet } from "../api";
import { SqlDataTable } from "../components/SqlDataTable";
import { openExportUsersModal } from "@/components/elements/ExportUsersModal";
import { Select } from "@/components/elements";

interface Data { name: string, event: string, article_id: string, value: number };

const dataQuery = `
select
  (select title from articles where id = article_id) as name,
  article_id,
  label as event,
  count(*) as value
from events
where type = 'event' and label in ('notification', 'open_notification', 'dismiss_notification')
and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
and article_id is not null
group by label, article_id
order by value desc;

`;

const extractUsersQuery = `
select distinct user_id
from events where type = 'event'
and label = ? and article_id = ?
and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
`
const extraColumns = [{field: 'event', label: 'Event'}]
export function ArticleNotificationsChart() {
  let type: 'include' | 'exclude' | '' = '';
  return <SqlDataTable
    label="Article Notifications"
    subtext="Notifications events by article(Incomplete data until more people update their apps) (Last 7 days)"
    width={900}
    extraColumns={extraColumns}
    onClick={(data: Data) => {
      let users: Set<string>;
      openExportUsersModal({
        headerContent: <UserExportHeader onType={t => type = t} data={`${data.event}(${data.name})`}/>,
        onDownload: async () => {
          users = await extractUserSet(extractUsersQuery, [data.event, data.article_id])
        },
        beforeCsv: async (exportUsers) => {
          return exportUsers.filter(d => {
            if(type === 'exclude') {
              return users.has(d.id) === false;
            } else {
              return users.has(d.id) === true;
            }
          });
        }
      })
    }}
  >{dataQuery}</SqlDataTable>
}


interface UserExportHeaderProps {
  data: string;
  onType: (type: 'include' | 'exclude') => void;
}

function UserExportHeader(props: UserExportHeaderProps) {
  const [type, setType] = React.useState<'include' | 'exclude'>('include');

  const options = React.useMemo(() => {
    const options: {label: string, value: string}[] = [
      {label: `Include only users in the ${props.data} event.`, value: 'include'},
      {label: `Exclude the users in the ${props.data} event`, value: 'exclude'},
    ];

    return options;
  }, []);

  React.useEffect(() => {
    props.onType(type);
  }, [type]);

  return <>
    Filter: 
    <Select
      size="small"
      value={type}
      changeEvent={e => setType(e.target.value as any)}
      options={options}/>
  </>
}